import { render, staticRenderFns } from "./creation-statistics.vue?vue&type=template&id=19f50070&scoped=true&"
import script from "./creation-statistics.vue?vue&type=script&lang=js&"
export * from "./creation-statistics.vue?vue&type=script&lang=js&"
import style0 from "./creation-statistics.vue?vue&type=style&index=0&id=19f50070&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f50070",
  null
  
)

export default component.exports